<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="card">
    <div class="body">
    <div class="col-lg-12">
      <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
      <br>
      <ValidationObserver ref="formValidation">
      <div class="row">
            <div class="col-md-4">
              <div class="mb-2 font-weight-bold">Configuración</div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.POSICIONAMIENTO"
                :disabled="!configuration.REPRESENTACION_LINEAL"
                id="posicionamiento">
                <label class="custom-control-label" for="posicionamiento">Posicionamiento</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.INDICATIVO_UNIDAD"
                id="indicativounidad">
                <label class="custom-control-label" for="indicativounidad">Indicativo Unidad</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-2 font-weight-bold">Representaciones</div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" @change="checkPosicionamiento()"
                  id="replineal" v-model="configuration.REPRESENTACION_LINEAL">
                <label class="custom-control-label" for="replineal">Representación Lineal</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.VERBAL_ORAL"
                id="verbaloral">
                <label class="custom-control-label" for="verbaloral">Verbal oral</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.RESP_VERBAL_ORAL"
                id="respverbaloral">
                <label class="custom-control-label" for="respverbaloral">
                  Respuesta Verbal Oral</label>
              </div>
            </div>
      </div>
      <br>
      <hr>
      <b-row>
        <b-col  style="text-align:center">
          <strong>Operaciones del ejercicio</strong>
          <b-button v-if="arrayEleOperation.length > 1" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>
      <br>
      <b-row  class="justify-content-md-center">
          <b-col col lg="2" style="text-align:center"><h6>Operando 1</h6></b-col>
          <b-col col lg="1" style="text-align:center"><h6>x</h6></b-col>
          <b-col col lg="2" style="text-align:center"><h6>Operando 2</h6></b-col>
          <b-col col lg="2" style="text-align:center"><h6>Resultado</h6></b-col>
      </b-row>
      <div>
        <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
            <b-row class="justify-content-md-center" style="margin-bottom: 10px">
              <b-col col lg="2">
                <ValidationProvider rules="required|max:7" v-slot="{ errors }">
                  <b-form-input type="number"
                    v-bind:id="'OPERADOR1' + index"
                    v-model="arrayEleOperation[index].OPERADOR1" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col col lg="1" style="text-align:center">
                x
              </b-col>
              <b-col col lg="2">
                <ValidationProvider rules="required|max:5" v-slot="{ errors }">
                  <b-form-input type="number"
                    v-bind:id="'OPERADOR2' + index"
                    v-model="arrayEleOperation[index].OPERADOR2" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col col lg="2">
                <b-form-input disabled
                    v-bind:id="'RESULT' + index"
                    type="number"
                    v-bind:value="getResult(index)" />
              </b-col>
            </b-row>
        </div>
      </div>
      <br>
      <b-row>
        <b-col class="text-center">
          <button v-on:click="saveStorage" :disabled="arrayEleOperation.length < 1" class="btn btn-info btn-lg">
          Guardar
        </button>
        </b-col>
      </b-row>
      </ValidationObserver>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import exercises from '../../exercises/exercise.vue';
import engineMixin from '../../../../mixins/engine';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});
extend('max', {
  validate(value, args) {
    return value.length <= args.length;
  },
  params: ['length'],
  message: 'Máx. {length} dígitos',
});

export default {
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  mixins: [engineMixin],
  components: {
    exercises,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      arrayEleOperation: [],
      // Mapear con los campos de la tabla SUMARESTAALG_CONF
      configuration: {
        ID: null,
        VERBAL_ORAL: false,
        REPRESENTACION_LINEAL: true,
        POSICIONAMIENTO: false,
        RESP_VERBAL_ORAL: false,
        INDICATIVO_UNIDAD: true,
        EJERCICIOS_ID: -1,
      },
    };
  },
  methods: {
    checkPosicionamiento() {
      if (!this.configuration.REPRESENTACION_LINEAL || this.configuration.REPRESENTACION_LINEAL === 0) {
        this.configuration.POSICIONAMIENTO = false;
      }
    },
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        POSICION: this.arrayEleOperation.length + 1,
        OPERADOR1: null,
        OPERADOR2: null,
      });
    },
    getResult(index) {
      return parseFloat(this.arrayEleOperation[index].OPERADOR1) * parseFloat(this.arrayEleOperation[index].OPERADOR2);
    },
    async getMotorData(id) {
      this.loading = true;

      try {
        const response = await this.axios.get('algorithmmultiplication/getmultiplication', {
          params: {
            ejercicios_id: id,
          },
        });
        this.configuration = response.data.config;
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            POSICION: element.POSICION,
            OPERADOR1: element.OPERADOR1,
            OPERADOR2: element.OPERADOR2,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el ejercicio', { type: 'warning' });
      }

      this.loading = false;
    },
  },
  async mounted() {
    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
      await this.getMotorData(this.exercise.ID);
    }
    // Read from storage data
    this.readFromStorage(this.type);
    this.updatedNumOperation();
  },
};
</script>
